import { render, staticRenderFns } from "./MasterAndFood.vue?vue&type=template&id=f11f8e86&scoped=true&"
import script from "./MasterAndFood.vue?vue&type=script&lang=js&"
export * from "./MasterAndFood.vue?vue&type=script&lang=js&"
import style0 from "./MasterAndFood.vue?vue&type=style&index=0&id=f11f8e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11f8e86",
  null
  
)

export default component.exports